export const cleanPretestOption = value => String(value ?? '').replace(/^[A-Ea-e][).:-]\s*/, '').trim();

export function pretestPreview(raw) {
  const questions = Array.isArray(raw) ? raw : raw?.questions || [];
  return questions.map((q, index) => {
    const opts = Array.isArray(q.options) ? q.options :
      'ABCDE'.split('').map(k => (q.options || q)[k]).filter(v => v != null && v !== '');
    const values = opts.map(cleanPretestOption);
    const answer = q.answer || q.correct_answer || '';
    const answerIndex = values.indexOf(answer);
    return { number: index + 1, question: q.question || q.question_text || '',
      options: values.map((v, i) => `${String.fromCharCode(65 + i)}) ${v}`),
      answer: /^[A-E]$/i.test(answer) ? answer.toUpperCase() : answerIndex >= 0 ? String.fromCharCode(65 + answerIndex) : answer };
  });
}

export function pretestPayload(questions, count) {
  if (!questions.length) throw new Error('Aktarılacak en az bir soru gerekli.');
  return questions.map((q, index) => {
    const prefix = `${index + 1}. soru: `;
    if (!q.question?.trim()) throw new Error(prefix + 'Soru metni boş.');
    const options = (q.options || []).map(cleanPretestOption);
    if (![4, 5].includes(count) || options.length !== count) throw new Error(prefix + `Tam olarak ${count} şık gerekli.`);
    const empty = options.findIndex(v => !v);
    if (empty >= 0) throw new Error(prefix + `${String.fromCharCode(65 + empty)} şıkkı boş.`);
    if (new Set(options.map(v => v.toLocaleLowerCase())).size !== count) throw new Error(prefix + 'Şıklar birbirinin aynısı olamaz.');
    let answer = String(q.answer || '').trim();
    if (/^[A-E]$/i.test(answer)) {
      const pos = answer.toUpperCase().charCodeAt(0) - 65;
      if (pos >= count) throw new Error(prefix + 'Cevap anahtarı mevcut bir şıkkı göstermeli.');
      answer = options[pos];
    } else if (!options.includes(answer)) throw new Error(prefix + 'Geçersiz cevap anahtarı.');
    return { question: q.question.trim(), options, correct_answer: String.fromCharCode(65 + options.indexOf(answer)) };
  });
}

export const pretestSignature = questions => JSON.stringify(questions.map(q => ({
  question: q.question?.trim(), options: (q.options || []).map(cleanPretestOption), answer: q.answer
})));
